import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Recycle } from "lucide-react";
import { isNativeApp } from "@/lib/utils";

export default function Footer() {
  if (isNativeApp()) {
    return (
      <footer className="hairline-t mt-12 py-5 pb-24 text-center" data-testid="app-mini-footer">
        <div className="flex justify-center gap-5 text-xs font-bold">
          <Link to="/cgu" data-testid="app-footer-cgu">CGU</Link>
          <Link to="/confidentialite" data-testid="app-footer-privacy">Confidentialité</Link>
          <Link to="/mentions-legales" data-testid="app-footer-legal">Mentions légales</Link>
        </div>
        <p className="mt-2 text-[10px] text-[color:var(--color-text-muted)]">© {new Date().getFullYear()} Fripri — Mode seconde main</p>
      </footer>
    );
  }
  return (
    <footer className="bg-black text-white mt-24 hidden md:block">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-4 gap-8">
        <div className="col-span-2 md:col-span-1">
          <div className="mb-4">
            <img src="/logo-fripri-full.svg" alt="Fripri" className="h-12 w-auto" />
          </div>
          <a href="https://play.google.com/store/apps/details?id=com.fripri.app" target="_blank" rel="noopener noreferrer" className="inline-block mb-4" data-testid="footer-play-badge">
            <img src="/google-play-badge.png" alt="Disponible sur Google Play" className="h-14 w-auto" />
          </a>
          <p className="text-sm text-white/70 leading-relaxed">
            La place française du marché de la mode seconde main. Moins de neuf, plus de style.
          </p>
        </div>
        <div>
          <div className="label text-[color:var(--color-mint)] mb-4 font-bold">Acheter</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/catalogue?category=vetements" className="hover:text-[color:var(--color-mint)]">Vêtements</Link></li>
            <li><Link to="/catalogue?category=chaussures" className="hover:text-[color:var(--color-mint)]">Chaussures</Link></li>
            <li><Link to="/catalogue?category=sacs" className="hover:text-[color:var(--color-mint)]">Sacs</Link></li>
            <li><Link to="/catalogue?category=accessoires" className="hover:text-[color:var(--color-mint)]">Accessoires</Link></li>
          </ul>
        </div>
        <div>
          <div className="label text-[color:var(--color-mint)] mb-4 font-bold">Vendre</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/vendre" className="hover:text-[color:var(--color-mint)]">Mettre en vente</Link></li>
            <li><Link to="/dashboard" className="hover:text-[color:var(--color-mint)]">Mon espace</Link></li>
            <li><Link to="/manifeste" className="hover:text-[color:var(--color-mint)]">Manifeste</Link></li>
            <li><Link to="/pro" className="hover:text-[color:var(--color-mint)]" data-testid="footer-pro">Fripri Pro — entreprise offerte 💼</Link></li>
            <li><Link to="/devenir-agent" className="hover:text-[color:var(--color-mint)]" data-testid="footer-become-agent">Devenir agent FRIPRI</Link></li>
          </ul>
        </div>
        <div>
          <div className="label text-[color:var(--color-mint)] mb-4 font-bold">Suivre</div>
          <div className="flex gap-3 mb-4">
            <a href="#" className="w-10 h-10 border border-white/30 flex items-center justify-center hover:bg-[color:var(--color-mint)] hover:text-black hover:border-[color:var(--color-mint)]"><Instagram size={16}/></a>
            <a href="mailto:contact@fripri.com" className="w-10 h-10 border border-white/30 flex items-center justify-center hover:bg-[color:var(--color-mint)] hover:text-black hover:border-[color:var(--color-mint)]"><Mail size={16}/></a>
          </div>
          <p className="text-xs text-white/60 flex items-center gap-2"><Recycle size={14}/> Made in France</p>
        </div>
        <div className="col-span-2 md:col-span-4 border-t border-white/10 pt-8 mt-4">
          <div className="label text-[color:var(--color-mint)] mb-4 font-bold">Informations légales</div>
          <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            <li><Link to="/mentions-legales" className="hover:text-[color:var(--color-mint)]" data-testid="footer-legal">Mentions légales</Link></li>
            <li><Link to="/confidentialite" className="hover:text-[color:var(--color-mint)]" data-testid="footer-privacy">Politique de confidentialité</Link></li>
            <li><Link to="/cgv" className="hover:text-[color:var(--color-mint)]" data-testid="footer-cgv">CGV</Link></li>
            <li><Link to="/cgu" className="hover:text-[color:var(--color-mint)]" data-testid="footer-cgu">CGU</Link></li>
            <li><Link to="/cookies" className="hover:text-[color:var(--color-mint)]" data-testid="footer-cookies">Cookies</Link></li>
            <li><Link to="/supprimer-mon-compte" className="hover:text-[color:var(--color-mint)]" data-testid="footer-account-deletion">Supprimer mon compte</Link></li>
            <li><a href="mailto:contact@fripri.com" className="hover:text-[color:var(--color-mint)]">Contact</a></li>
          </ul>
          <p className="text-xs text-white/50 mt-4">
            Édité par <strong>ECOLOVALO</strong> — Association déclarée · SIREN 801 257 593 · 5 Boulevard Galliéni, 92390 Villeneuve-la-Garenne · 09 70 70 94 24
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-8 py-4 text-xs text-white/50 flex flex-col md:flex-row justify-between gap-2">
          <span>© {new Date().getFullYear()} Fripri · Tous droits réservés</span>
          <span>Vendez. Achetez. Réutilisez.</span>
        </div>
      </div>
    </footer>
  );
}
